import { Alert } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { apiApproveRequest, apiRejectRequest } from '../../api/api'
import { CommunityContext } from '../CommunityContext'
import './CommunityRequest.css'

const CommunityRequestList = ({communityData}) => {
  const { setCommunityData } = useContext(CommunityContext)
  let { id } = useParams('0')
  const [community, setcommunity] = useState(communityData)
  const [showAlert, setshowAlert] = useState(false)
  const [alertVariant, setalertVariant] = useState("")
  const [alertText, setalertText] = useState("")
  const buttonStyle = {
    height:"30px",
    width: "100px"
  }
  const handleAlert = () => {
    setshowAlert(true)
    setTimeout(() => setshowAlert(false), 5000)
  }
  const handleAccept = (email) => {
    apiApproveRequest(id, email).then(() => {
      setalertVariant("success")
      setalertText(`${email} has been added to member list`)
      handleAlert()
      let new_pending_list = community.pendingMembers.filter((val) => {
        return val !== email
      })
      community.publicMembers.push(email)
      setcommunity({...community, pendingMembers:new_pending_list})
      setCommunityData({...community, pendingMembers:new_pending_list})
    }).catch(error => {
      setalertVariant("error")
      if (error.response !== undefined){
        setalertText(error.response.data.detail)
        console.log(error.response.data.detail)
      } else {
        setalertText("Something went wrong")
      }
      handleAlert()
    })
  }
  const handleDecline = (email) => {
    apiRejectRequest(id, email).then(() => {
      //TODO: refetch community data
      setalertVariant("success")
      setalertText(`${email} has been removed from pending list`)
      let new_list = community.pendingMembers.filter((val) => {
        return val !== email
      })
      setcommunity({...community, pendingMembers:new_list})
      setCommunityData({...community, pendingMembers:new_list})
      handleAlert()
    }).catch(error => {
      setalertVariant("error")
      if (error.response !== undefined){
        setalertText(error.response.data.detail)
      } else {
        setalertText("Something went wrong")
      }
      handleAlert()
    })
  }
  useEffect(() => {
    setcommunity(communityData)
  }, [communityData])
  
  return (
    <>
      {showAlert && 
      <Alert style={{marginBottom:"24px"}} severity={alertVariant} onClose={() => setshowAlert(false)}>
        {alertText}
      </Alert>
    }
    <div id="communityRequestList">
      {community.pendingMembers.length === 0 ?
        <div>There are no pending members in this community</div>
        :<>
          {
            community.pendingMembers.map((email, index)=>(
              <div className="member-card" key={index}>
                <div>{email}</div>
                <div className='button-container'>
                  <button className='button-secondary' onClick={() => handleDecline(email)} style={buttonStyle}>Reject</button>
                  <button className='button-primary' onClick={() => handleAccept(email)} style={buttonStyle}>Approve</button>
                </div>
              </div>
            ))
          }
        </>
      }
    </div>
    </>

  )
}

export default CommunityRequestList